import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './CakeBookDemo.css';

const CakeBookDemo = () => {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    shop_name: '',
    owner_name: '',
    mobile: '',
    email: '',
    city: '',
    shop_type: '',
    preferred_demo_time: '',
  });

  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [messageType, setMessageType] = useState('');

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    if (message) {
      setMessage('');
      setMessageType('');
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (
      !formData.shop_name.trim() ||
      !formData.owner_name.trim() ||
      !formData.mobile.trim()
    ) {
      setMessage(
        'Shop name, owner name and mobile number are required.'
      );
      setMessageType('error');
      return;
    }

    setLoading(true);
    setMessage('');
    setMessageType('');

    try {
      const response = await fetch('/api/cake/demo-request', {
        method: 'POST',

        headers: {
          'Content-Type': 'application/json',
        },

        body: JSON.stringify({
          shop_name: formData.shop_name.trim(),
          owner_name: formData.owner_name.trim(),
          mobile: formData.mobile.trim(),
          email: formData.email.trim(),
          city: formData.city.trim(),
          shop_type: formData.shop_type,
          preferred_demo_time:
            formData.preferred_demo_time,
        }),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(
          data.message ||
            'Unable to submit demo request.'
        );
      }

      setMessage(
        'Demo request submitted successfully. VAKRA team will contact you.'
      );

      setMessageType('success');

      setFormData({
        shop_name: '',
        owner_name: '',
        mobile: '',
        email: '',
        city: '',
        shop_type: '',
        preferred_demo_time: '',
      });

    } catch (error) {
      console.error(
        'Cake demo request error:',
        error
      );

      setMessage(
        error.message ||
          'Unable to submit demo request.'
      );

      setMessageType('error');

    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="cake-demo-page">

      {/* TOPBAR */}
      <header className="cake-demo-topbar">

        <div
          className="cake-demo-brand"
          onClick={() => navigate('/')}
        >
          <div className="cake-demo-logo">
            🎂
          </div>

          <div>
            <h2>VAKRA CAKE</h2>
            <span>Cake Business Platform</span>
          </div>
        </div>


        <div className="cake-demo-top-actions">

          <button
            type="button"
            className="cake-demo-login"
            onClick={() =>
              navigate('/cake/login')
            }
          >
            Login
          </button>

          <button
            type="button"
            className="cake-demo-signup"
            onClick={() =>
              navigate('/cake/signup')
            }
          >
            Sign Up
          </button>

        </div>

      </header>


      {/* MAIN */}
      <main className="cake-demo-main">

        {/* LEFT */}
        <section className="cake-demo-left">

          <div className="cake-demo-left-inner">

            <span className="cake-demo-badge">
              Free Product Demo
            </span>

            <h1>
              See How
              <span> VAKRA Cake </span>
              Can Help Your Business
            </h1>

            <p>
              Book a demo and understand how you can
              manage your cakes, orders, customers,
              billing and records from one simple
              platform.
            </p>


            <div className="cake-demo-benefits">

              <div>
                <span>🎂</span>

                <section>
                  <strong>
                    Cake Management
                  </strong>

                  <p>
                    Add cakes, prices, weights,
                    flavors and images.
                  </p>
                </section>
              </div>


              <div>
                <span>📦</span>

                <section>
                  <strong>
                    Order Management
                  </strong>

                  <p>
                    See how customer orders can be
                    received and managed.
                  </p>
                </section>
              </div>


              <div>
                <span>📊</span>

                <section>
                  <strong>
                    Business Records
                  </strong>

                  <p>
                    Manage customers, billing and
                    business records.
                  </p>
                </section>
              </div>

            </div>

          </div>

        </section>


        {/* RIGHT */}
        <section className="cake-demo-right">

          <div className="cake-demo-form-card">

            <div className="cake-demo-form-heading">

              <h2>
                Book Your Demo
              </h2>

              <p>
                Enter your business details and our
                team will contact you.
              </p>

            </div>


            {message && (
              <div
                className={
                  messageType === 'success'
                    ? 'cake-demo-message success'
                    : 'cake-demo-message error'
                }
              >
                {message}
              </div>
            )}


            <form
              className="cake-demo-form"
              onSubmit={handleSubmit}
            >

              <div className="cake-demo-form-group">

                <label>
                  Cake Shop / Business Name
                  <span>*</span>
                </label>

                <input
                  type="text"
                  name="shop_name"
                  value={formData.shop_name}
                  onChange={handleChange}
                  placeholder="Example: Sweet Cake House"
                />

              </div>


              <div className="cake-demo-two-columns">

                <div className="cake-demo-form-group">

                  <label>
                    Owner Name
                    <span>*</span>
                  </label>

                  <input
                    type="text"
                    name="owner_name"
                    value={formData.owner_name}
                    onChange={handleChange}
                    placeholder="Owner name"
                  />

                </div>


                <div className="cake-demo-form-group">

                  <label>
                    Mobile Number
                    <span>*</span>
                  </label>

                  <input
                    type="tel"
                    name="mobile"
                    value={formData.mobile}
                    onChange={handleChange}
                    placeholder="Mobile number"
                    maxLength="15"
                  />

                </div>

              </div>


              <div className="cake-demo-form-group">

                <label>
                  Email Address
                </label>

                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="your@email.com"
                />

              </div>


              <div className="cake-demo-two-columns">

                <div className="cake-demo-form-group">

                  <label>
                    City
                  </label>

                  <input
                    type="text"
                    name="city"
                    value={formData.city}
                    onChange={handleChange}
                    placeholder="Your city"
                  />

                </div>


                <div className="cake-demo-form-group">

                  <label>
                    Business Type
                  </label>

                  <select
                    name="shop_type"
                    value={formData.shop_type}
                    onChange={handleChange}
                  >
                    <option value="">
                      Select
                    </option>

                    <option value="cake_shop">
                      Cake Shop
                    </option>

                    <option value="home_baker">
                      Home Baker
                    </option>

                    <option value="bakery">
                      Bakery
                    </option>

                    <option value="custom_cake_studio">
                      Custom Cake Studio
                    </option>

                    <option value="other">
                      Other
                    </option>
                  </select>

                </div>

              </div>


              <div className="cake-demo-form-group">

                <label>
                  Preferred Demo Time
                </label>

                <select
                  name="preferred_demo_time"
                  value={
                    formData.preferred_demo_time
                  }
                  onChange={handleChange}
                >
                  <option value="">
                    Select preferred time
                  </option>

                  <option value="morning">
                    Morning
                  </option>

                  <option value="afternoon">
                    Afternoon
                  </option>

                  <option value="evening">
                    Evening
                  </option>

                  <option value="anytime">
                    Anytime
                  </option>
                </select>

              </div>


              <div className="cake-demo-info">
                After submitting the request, VAKRA
                team will review your details and
                contact you for the demo.
              </div>


              <button
                type="submit"
                className="cake-demo-submit"
                disabled={loading}
              >
                {
                  loading
                    ? 'Submitting...'
                    : 'Book Demo'
                }
              </button>


              <div className="cake-demo-bottom">

                Already have an account?

                <button
                  type="button"
                  onClick={() =>
                    navigate('/cake/login')
                  }
                >
                  Login
                </button>

              </div>

            </form>

          </div>

        </section>

      </main>

    </div>
  );
};

export default CakeBookDemo;
